import styled from "styled-components";

export const HParent = styled.main`
  width: 95%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  
  
  `;